import { render, staticRenderFns } from "./AssociateSubAccountDialog.vue?vue&type=template&id=3163de21"
import script from "./AssociateSubAccountDialog.vue?vue&type=script&lang=js"
export * from "./AssociateSubAccountDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports